import * as React from 'react';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import './custom-image-gallery.css'; // Importa el archivo CSS personalizado
import CircularProgress from '@mui/material/CircularProgress'; // Importamos el spinner de MUI
import Box from '@mui/material/Box';

function ImageGalleryComponent({ images }) {
    const [loading, setLoading] = React.useState(true); // Estado para el loader

    // Simulamos la carga de las imágenes (esto dependerá de cómo se gestionan en la realidad)
    React.useEffect(() => {
        if (images && images.length > 0) {
            setLoading(false); // Se desactiva el loader cuando las imágenes están disponibles
        }
    }, [images]);

    

    return (
        <div>
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                    <CircularProgress /> 
                </Box>
            ) : (
                <ImageGallery 
                    items={images}
                    showPlayButton={false}
                    showThumbnails={false}
                    showBullets={true}
                    autoPlay={false}
                    showFullscreenButton={false}
                />
            )}
        </div>
    );
}

export default ImageGalleryComponent;
